import { useMemo } from "react";

import moment from "moment";
import { twMerge } from "tailwind-merge";

import { useFeatureFlags } from "@hooks/http";

import { useMetricsExplorerContext } from "../hooks";

interface Props {
  className?: string;
}

export const WarningMessage = ({ className }: Props) => {
  const { hasFeatureFlag } = useFeatureFlags();
  const {
    filters: { dateRangeInterval, timeGranularity },
  } = useMetricsExplorerContext();

  const numDataPoints = useMemo(() => {
    return (
      moment(dateRangeInterval.endDate).diff(
        dateRangeInterval.startDate,
        (
          {
            hourly: "hours",
            daily: "days",
            weekly: "weeks",
            monthly: "months",
          } as const
        )[timeGranularity],
      ) + 1
    );
  }, [dateRangeInterval, timeGranularity]);

  if (!hasFeatureFlag("enableMetricsExplorerCorrelationAnalysis")) {
    return;
  }

  if (numDataPoints >= 30) {
    return;
  }

  return (
    <div className={twMerge("px-6 pt-4", className)}>
      <div className="flex text-sm">
        <div className="bg-[#36B7B7] rounded-s-lg flex items-center justify-center w-9">
          <i className="fa-regular fa-sharp fa-info-circle text-white" />
        </div>
        <div className="flex-1 p-2 pr-3 bg-[#EDFBFB] rounded-e-lg">
          Correlation accuracy improves with more data. For more accurate
          increase the time period to include 30+ dates.
        </div>
      </div>
    </div>
  );
};
